import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtErr, API } from "../../lib/api";
import { PageHeader, inputCls, EmptyState } from "../../components/bits";
import { Inbox, Eye, Search } from "lucide-react";
import { HIJRI_MONTHS, fmtSize, fmtHijri } from "../admin/AdminCirculars";

export default function CircularsIn() {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  const [month, setMonth] = useState("");

  useEffect(() => {
    api.get("/portal/circulars").then((r) => setItems(r.data)).catch((e) => toast.error(fmtErr(e)));
  }, []);

  const filtered = (items || []).filter((c) =>
    (!q || c.title.includes(q)) && (!month || (c.issue_date || "").split("/")[1] === month));

  if (items === null) return <div className="text-center text-mutext py-20 font-head">جارٍ التحميل …</div>;

  return (
    <div data-testid="circulars-in-page">
      <PageHeader title="التعاميم الواردة" sub="التعاميم الصادرة من الإدارة العامة، مرتبة حسب تاريخ الإصدار" />

      <div className="flex gap-3 mb-5 flex-wrap">
        <select data-testid="circular-in-month-filter" value={month} onChange={(e) => setMonth(e.target.value)} className={`${inputCls} w-40`}>
          <option value="">كل الأشهر</option>
          {HIJRI_MONTHS.map((m, i) => <option key={m} value={String(i + 1).padStart(2, "0")}>{m}</option>)}
        </select>
        <div className="relative flex-1 min-w-[220px]">
          <Search className="w-4 h-4 absolute right-3 top-3 text-mutext" />
          <input data-testid="circular-in-search" value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="ابحث في عناوين التعاميم…" className={`${inputCls} pr-9`} />
        </div>
      </div>

      {filtered.length === 0 ? (
        <EmptyState testid="circulars-in-empty" text="لا توجد تعاميم واردة حالياً" />
      ) : (
        <div className="bg-surface rounded-2xl border border-brd shadow-md overflow-hidden">
          <div className="overflow-auto">
            <table className="w-full text-sm" data-testid="circulars-in-table">
              <thead>
                <tr className="bg-bg text-mutext">
                  <th className="text-right px-4 py-2.5 font-head text-[11px]">م</th>
                  <th className="text-right px-4 py-2.5 font-head text-[11px]">عنوان التعميم</th>
                  <th className="text-right px-4 py-2.5 font-head text-[11px]">تاريخ الإصدار</th>
                  <th className="text-right px-4 py-2.5 font-head text-[11px]">النوع</th>
                  <th className="text-right px-4 py-2.5 font-head text-[11px]">الحجم</th>
                  <th className="text-right px-4 py-2.5 font-head text-[11px]">إجراءات</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((c, i) => (
                  <tr key={c.id} data-testid={`circular-in-row-${c.id.slice(0, 8)}`} className="border-b border-brd/50 last:border-0 hover:bg-bg transition-colors">
                    <td className="px-4 py-3 text-mutext">{i + 1}</td>
                    <td className="px-4 py-3 font-bold flex items-center gap-2">
                      <Inbox className="w-3.5 h-3.5 text-turq-600 shrink-0" /> {c.title}
                    </td>
                    <td className="px-4 py-3" dir="ltr">{fmtHijri(c.issue_date)}</td>
                    <td className="px-4 py-3 text-[11px] font-bold">{c.file_type || "—"}</td>
                    <td className="px-4 py-3 text-[11px]">{fmtSize(c.size)}</td>
                    <td className="px-4 py-3">
                      {c.storage_path ? (
                        <a data-testid={`circular-in-view-${c.id.slice(0, 8)}`} href={`${API}/portal/circulars/file/${c.id}`} target="_blank" rel="noreferrer"
                          className="inline-flex h-8 px-3 rounded-lg bg-turq-100 dark:bg-surface2 items-center gap-1 text-[11px] font-bold text-turq-900 dark:text-turq-300 hover:scale-105 transition-transform">
                          <Eye className="w-3.5 h-3.5" /> عرض
                        </a>
                      ) : <span className="text-[11px] text-mutext">—</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
